import Flickity from "flickity";
import "flickity/css/flickity.css";

(function ($, Drupal) {
  Drupal.behaviors.responsiveSlider = {
    attach: function (context, settings) {
      // Verificar si existen los elementos necesarios antes de ejecutar el código

      const views = [
        '.view-investigation-education',
        '.view-day-healt',
        '.view-indicators'
      ];

      const hasRequiredElements = document.querySelector(views.join(', '));

      if (hasRequiredElements) {
        const breakpoint = 992;
        let flkty;
        let activeIndex = 0;
        const sliderSelector = views.map(view => `${view} .fieldset-wrapper > .radio > .form-radios`).join(', ');
        // Función para inicializar el slider en una posición específica
        function initSlider(startIndex = 0, prevNextButtons = true) {
          const sliders = document.querySelectorAll(sliderSelector);
          sliders.forEach((slider) => {
            if (slider && !flkty) {
              flkty = new Flickity(slider, {
                cellAlign: 'center',
                contain: true,
                wrapAround: false,
                pageDots: false,
                prevNextButtons: prevNextButtons,
                initialIndex: startIndex,
              });
            }
          });
        }

        // Función para destruir el slider
        function destroySlider() {
          if (flkty && typeof flkty.destroy === 'function') {
            activeIndex = flkty.selectedIndex;
            flkty.destroy();
            flkty = null;
          }
        }

        // Verifica el tamaño de la ventana y activa/desactiva el slider
        function checkSlider() {
          if (window.innerWidth < breakpoint) {            
            destroySlider();
            initSlider(activeIndex);
          } else {
            destroySlider();
            //initSlider(activeIndex, false);
          }
        }

        function onReadyOrResize() {
          if (window.innerWidth < breakpoint) {
            let clickedItem = 0
            const sliderSelector = views
            .map(view => `${view} .fieldset-wrapper > .radio > .form-radios input[type="radio"]:checked`)
            .filter(selector => document.querySelector(selector) !== null);
          
            sliderSelector.forEach(selector => {
              const s = document.querySelector(selector);
              clickedItem = s.closest('.radio');
            });

            const sliderItems = document.querySelectorAll(
              views.map(view => `${view} .fieldset-wrapper > .radio > .form-radios .radio`).join(', ')
            );

            if (clickedItem && sliderItems.length > 0) {
              const activeIndex = Array.from(sliderItems).indexOf(clickedItem);
              //checkSlider();
              initSlider(activeIndex);
            }
          }
        }

        // Ejecuta la función al cargar la página y al redimensionar la ventana
        window.addEventListener('load', checkSlider);
        window.addEventListener('resize', checkSlider);
        window.addEventListener('DOMContentLoaded', onReadyOrResize);


        // Detectar cuando se completa una llamada AJAX en Drupal usando el evento drupalAjax
        $(document).ajaxSuccess(function(event, xhr, settings) {
          if (window.innerWidth < breakpoint) {
            destroySlider();
            
            initSlider(activeIndex);
          } else {
            destroySlider();
            //initSlider(activeIndex, false);
          }
        });

        // Capturar clics en los botones de opción (radio buttons) solo en mobile


        const viewDayHealth = document.querySelector(".view-day-healt, .view-investigation-education", context); 

        const formComposite = document.querySelectorAll(".form-composite .form-radios .js-form-type-radio", context);
        if (formComposite) {
          const editActionsInput = viewDayHealth.querySelector(".form-actions .form-submit", context);
          formComposite.forEach(element => {
            if (window.innerWidth < breakpoint) {
              const clickedItem = element.closest('.radio');            
              const sliderItems = document.querySelectorAll(
                views.map(view => `${view} .fieldset-wrapper > .radio > .form-radios .radio`).join(', ')
              );
              if (clickedItem && sliderItems.length > 0) {
                const activeIndex = Array.from(sliderItems).indexOf(clickedItem);
                if (flkty) {
                  flkty.select(activeIndex);
                }
              }
            }
            
            element.addEventListener('click', () => {
              setTimeout(() => {                
                editActionsInput.click();
              }, 500);
            })
          });
        }

     /*    document.addEventListener('click', function (event) {
          console.log(".......");
          
          if (window.innerWidth < breakpoint) {
            const clickedItem = event.target.closest('.radio');            
            const sliderItems = document.querySelectorAll(
              views.map(view => `${view} .fieldset-wrapper > .radio > .form-radios .radio`).join(', ')
            );
            if (clickedItem && sliderItems.length > 0) {
              const activeIndex = Array.from(sliderItems).indexOf(clickedItem);
              if (flkty) {
                flkty.select(activeIndex);
              }
            }
          }
        }); */
      }
    }
  };
})(jQuery, Drupal);
